import React from "react";
import { defineMessages, useIntl } from "react-intl";
import "../../../components/filter/FilterGroupNew.js";
import "moment-timezone";
import "../../../components/input/validation.js";
import "../../../components/input/DatePicker.js";
import "../../../components/input/DateRangePicker.js";
import "../../../components/input/StyledInput.js";
import "../../../components/input/FormInput.js";
import "../../../components/input/StyledFormInputHoc.js";
import "../../../components/input/DateSinglePicker.localize.js";
import "../../../components/input/hooks.js";
import "@mui/material";
import "../../../components/filter/dateRangeFilter/DateRangeFilter.js";
import "../../../components/filter/date-filter/DateFilter.js";
import "../../../components/filter/TextFilterWithDropdown.js";
import "../../../components/filter/MultiStepFilterDrawer.js";
import "../../../components/filter/dateRangeFilter/MultiStepFilterDatePicker.js";
import { Select, EmptyPlaceholder } from "../../../components/select/Select.js";
import "../../../components/filter/TextFilter.js";
import "../../../components/filter/valueRangeFilter/ValueRangeFilter.js";
import "../../../components/filter/dateRangeFilter/localized.js";
import "../../../components/filter/dateRangeFilter/DateRangeHistoricalFilter.js";
import "../../../components/filter/MultiStepFilterApplyButton.js";
import "../../../components/filter/MultiStepFilterInput.js";
import "../../../components/filter/MultiStepFilterHoc.js";
import { MultiSelectWithExcludeFilter } from "../../../components/filter/MultiSelectWithExcludeFilter.js";
import "../../../components/filter/PhoneFilter.js";
import "../../../components/chip/ChipRenderer.js";
import "../../../components/select/selectStyle.js";
import "../../../components/select/MultiSelectFooter.js";
import "../../../components/select/MultiSelect.js";
import "../../../components/select/MultiSelectItem.js";
import "../../../components/select/SelectArrowIcon.js";
import "../../../components/select/VirtualizedMultiSelectOptionList.js";
import "../../../components/select/SingleSelect.js";
import "../../../components/select/MultiSelectWithExclude.js";
import "../../../components/select/MultiSelectTextCounterWithTooltip.js";
import { useCountries } from "../hooks.js";
const localized = defineMessages({
  label: {
    id: "CountryFilter_label",
    defaultMessage: "Country"
  },
  searchPlaceholder: {
    id: "CountryFilter_searchPlaceholder",
    defaultMessage: "Search country"
  },
  countries: {
    id: "CountryFilter_countries",
    defaultMessage: "countries"
  }
});
function CountryFilter({
  value,
  onChange,
  hasLabel = true,
  inputLabel = localized.label,
  countryEntity,
  config,
  fullWidthInput,
  selectMode = "multi",
  disabled
}) {
  const { formatMessage } = useIntl();
  const { countries } = useCountries({
    viewType: "CountryFilter",
    countryEntity,
    config,
    validateFilter: () => true,
    isCancelable: false
  });
  return selectMode === "multi" ? /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    MultiSelectWithExcludeFilter,
    {
      mode: "client",
      virtualization: true,
      value,
      onChange,
      options: countries.map((c) => ({ value: c.iso2Code, label: c.name })),
      searchPlaceholder: localized.searchPlaceholder,
      showResetButton: true,
      total: countries?.length,
      itemsName: formatMessage(localized.countries),
      inputLabel: hasLabel ? inputLabel : null,
      fullWidthInput,
      disabled
    }
  )) : /* @__PURE__ */ React.createElement(
    Select,
    {
      mode: "client",
      virtualization: true,
      value,
      onSubmit: onChange,
      options: countries.map((c) => ({ value: c.iso2Code, label: c.name })),
      searchPlaceholder: localized.searchPlaceholder,
      showResetButton: true,
      resetMode: "button",
      total: countries?.length,
      label: hasLabel ? inputLabel : null,
      fullWidthInput,
      hasSearch: true,
      horizontalPosition: "left",
      emptyPlaceholder: EmptyPlaceholder.All,
      disabled
    }
  );
}
export {
  CountryFilter
};
//# sourceMappingURL=CountryFilter.js.map
